import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

// Sentry browser init runs ONCE on first router construction. Browser-only:
// the server bundle skips the dynamic import entirely via the `typeof
// window` guard. The instrument file calls Sentry.init({...}) at module
// load time if VITE_SENTRY_DSN is set.
//
// Filename is `instrument-browser.ts` (not `instrument.client.ts`) —
// TanStack Start's import-protection plugin blocks `**/*.client.*`
// from being referenced by code shared with the server bundle, and
// this router file IS shared. Hyphen avoids the pattern; the runtime
// guard above keeps it server-safe regardless.
if (typeof window !== "undefined") {
  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  void import("./instrument-browser");
}

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  return router;
};
